<template>
    <v-card-text class="narrow-container">
        <v-text-field
            ref="twoFACode"
            v-model="twoFA.code"
            :error-messages="twoFA.$errors.code"
            label="Enter 2FA Code"
            outlined
            type="text"
            @blur="twoFA.validate('code')"
            @input="delete twoFA.$errors.code"
            @keyup.native.enter="onSubmitWith2FA"
        />

        <v-btn :loading="loading" block color="primary" depressed large rounded @click="onSubmitWith2FA">
            Send email
        </v-btn>
    </v-card-text>
</template>

<script>
import * as rules from "vuelidate/lib/validators";

export default {
    name: "ForgotPassword2FA",

    created() {
        if (!this.$route.params.email) {
            this.$router.push({ name: 'ForgotPassword' });
        }

        this.email = this.$route.params.email;

        this.$nextTick(() => {
            this.$refs.twoFACode.$el.querySelector('input').focus();
        });
    },

    data() {
        return {
            loading: false,
            email: null,
            twoFA: new Form(this, 'twoFA', {
                code: null
            })
        };
    },

    validations: {
        twoFA: {
            code: {
                required: rules.required
            }
        }
    },

    methods: {
        async onSubmitWith2FA() {
            if (!this.twoFA.validate()) return;

            this.loading = true;

            await this.$apiService
                .post("password/email", {
                    email: this.email,
                    code: this.twoFA.code
                })
                .then(response => {
                    if (response.data?.google2fa_enable) {
                        this.$snackbar(`Incorrect two factor authentication code.`, "error");
                    } else {
                        this.$router.push({ name: 'ForgotPassword.EmailSent' });
                    }
                })
                .catch(err => {
                    this.$snackbar(`Incorrect two factor authentication code.`, "error");
                });

            this.loading = false
        }
    }
}
</script>